import { HOST, } from "common/constants";
import React, { useEffect } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import parse from "html-react-parser";
import { Swiper, SwiperSlide } from "swiper/react";
import { A11y, Navigation, Pagination } from "swiper";
import { Fancybox } from "@fancyapps/ui";
import { useTranslation } from "react-i18next";

import "swiper/css";
import "swiper/css/bundle";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import classes from "./newsDescription.module.scss";

const NewsDescription = ({ news }) => {
  const isMobile = useMediaQuery("(max-width: 575px)");
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  useEffect(() => {
    Fancybox.bind('[data-fancybox="gallery"]', {});
    return () => Fancybox.destroy();
  }, []);


  
  // Переведённые поля
  const translatedTitle =
    news?.[`title_${lang}`] ?? news?.title_ky ?? news?.title;
   
    const translatedDescription =
    news?.[`description_${lang}`] ?? news?.description_ky ?? news?.description;
  
    const parsedDescription = parse(translatedDescription || t("noDescription"), {
    replace: (domNode) => {
      if (
        domNode.name === "img" &&
        domNode.attribs?.src &&
        domNode.attribs.src.startsWith("/")
      ) {
        domNode.attribs.src = HOST + domNode.attribs.src;

        // Удаляем inline-стили
        delete domNode.attribs.style;

        return (
          <a data-fancybox="gallery" href={domNode.attribs.src}>
            <img
              src={domNode.attribs.src}
              alt="img"
              style={{
                maxWidth: "100%",
                width: "100%",
                height: "auto",
                display: "block",
                position: "static",
              }}
            />
          </a>
        );
      }

      if (domNode.name === "a" && domNode.attribs?.href) {
        if (domNode.attribs.href.startsWith("/")) {
          domNode.attribs.href = HOST + domNode.attribs.href;
        }

        if (
          domNode.attribs.href.startsWith("http") ||
          domNode.attribs.href.startsWith("https")
        ) {
          domNode.attribs.target = "_blank";
          domNode.attribs.rel = "noopener noreferrer";
        }
      }

      return undefined;
    },
  });

  return (
    <Box className="pagin">
      {news?.news_detail_images?.length > 0 && (
        <Swiper
          navigation
          pagination
          centeredSlides
          loop
          modules={[Pagination, Navigation, A11y]}
          style={{
            "--swiper-navigation-color": "#FFFFFF",
            "--swiper-navigation-size": isMobile ? "24px" : "44px",
          }}
        >
          {news.news_detail_images.map((item, idx) => (
            <SwiperSlide key={idx}>
              <a data-fancybox="gallery" href={item?.image}>
                <Box
                  component="img"
                  className={classes.bigImg}
                  src={item?.image}
                  alt={`image-${idx}`}
                />
                <Box className={classes.title}>
                  <Typography className={classes.titleMore}>
                    {translatedTitle}
                  </Typography>
                </Box>
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      )}

      <Box className={classes.description}>{parsedDescription}</Box>
    </Box>
  );
};

export default NewsDescription;
